module.exports = __webpack_public_path__ + "img/zuijia_38.e65f821b.png";